import Peer from 'peerjs'

export const PEER_APP = 'HOGARFILMS';

const PeerSettings = {
  secure:true,
  // host: 'my-peerjs-hog.herokuapp.com',
  host: '0.peerjs.com',
  port: 443,
  // debug: 3
};

const DEFAULT_SETTINGS = {
  nbr_films: 3,
  resume_prompt: `Résume en 25 mots et en français, chacun des films suivants, sans utiliser les mots du titre dans le résumé :`,
  image_prompt: `Crée une affiche sans texte pour le film ":titre" sorti en :annee.`,
  infos_titre: true,
  infos_date: true,
  infos_duree: true,
  infos_genre: true,
  infos_note: true,
  // infos_image: true,
  // infos_resume: true,
  infos_resume_chatgpt: true,
  infos_image_chatgpt: true,
};

class Connection {
  constructor(ID, name, options={}) {
    this.ID = PEER_APP+'-'+ID;
    this.options = options;
    this.name = name;

    this._onUpdateState = null;
    this._onUpdateMesFilms = [];

    this.loading = false;

    this.mesFilms = [];
    if(window.localStorage.getItem('films') !== null) {
      try {
        this.mesFilms = JSON.parse(window.localStorage.getItem('films'));
      }
      catch(err) {}
    }

    const peer = this.peer = new Peer(this.ID, PeerSettings);

    peer.on('error', this.options.onError);

    function beforeunload(event) {
      event.preventDefault();
      event.returnValue = true;
    }
    window.addEventListener("beforeunload", beforeunload);
    function unload(event) {
      this.close();
    }
    window.addEventListener("unload", unload);

    this.peer.on('close', () => {
      window.removeEventListener("beforeunload", beforeunload);
      window.removeEventListener("unload", unload);
      options.onClose?.();
    });
  }

  setState(state) {
    this.state = state;
    this._onUpdateState?.(state);
  }

  setMesFilms(mesFilms) {
    if(this.state.state !== 'open')
      return;

    this.mesFilms = mesFilms;
    window.localStorage.setItem('films', JSON.stringify(mesFilms));
    this._onUpdateMesFilms?.(mesFilms);
  }

  ajouter(film) {
    this.setMesFilms([...this.mesFilms, film]);
  }

  supprimer(name) {
    let cp = [];
    for(let f of this.mesFilms) {
      if(f.name !== name)
        cp.push(f);
    }
    this.setMesFilms(cp);
  }

  onUpdateState(cb) {
    this._onUpdateState = cb;
    cb(this.state);
  }

  offUpdateState() {
    this._onUpdateState = null;
  }

  onUpdateMesFilms(cb) {
    this._onUpdateMesFilms = cb;
    cb(this.mesFilms);
  }

  offUpdateMesFilms() {
    this._onUpdateMesFilms = null;
  }

  close() {
    console.log('CLOSE !!!')
    this.peer.destroy();
  }

  getSetting(k) {
    return this.state?.settings[k] ?? DEFAULT_SETTINGS[k];
  }
}

export default Connection